import { type NonEmptyArray } from '../types';

export const MOSCOW_ID = 1;
export const SPB_ID = 2;
export const MOSCOW_AND_REGION_ID = -1;
export const MOSCOW_REGION_ID = 4593;
export const SPB_REGION_ID = 4588;
export const SPB_AND_REGION_ID = -2;

export const REGIONS_WITH_UNDERGROUND: NonEmptyArray<number> = [
  MOSCOW_ID,
  SPB_ID,
  MOSCOW_REGION_ID,
  4743,
  4777,
  4885,
  4897,
  4966,
];
export const PIK_PROMO_REGIONS: NonEmptyArray<number> = [MOSCOW_ID, MOSCOW_REGION_ID];
